import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSaveVideoEdits.meta';

export type TrackSaveVideoEditsParams = {
  save_type: 'new_asset' | 'new_version';
};

export const useTrackSaveVideoEdits = () => {
  const { track } = useAnalyticsUtilities();

  const trackSaveVideoEdits = useCallback(
    (params: TrackSaveVideoEditsParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSaveVideoEdits };
};
